export const defaultCamerasProfileWidgets = [
	{
		enabled: true,
		id: "linked_items",
		index: 0
	},
	{
		enabled: true,
		id: "activities",
		index: 1
	},
	{
		enabled: true,
		id: "live_camera",
		index: 2
	},
	{
		enabled: true,
		id: "files",
		index: 3
	},
	{
		enabled: true,
		id: "map",
		index: 4
	},
	{
		enabled: true,
		id: "details",
		index: 5
	},
	{
		enabled: true,
		id: "alerting_zones",
		index: 6
	}
];
